type SVGProps = {
  color?: string;
  width?: string | number;
  height?: string | number;
};

const DownArrow = ({ color, width, height }: SVGProps) => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 24 24'
  >
    <path
      fill={color}
      fillRule='nonzero'
      d='M12.75 19.19l7.72-7.72a.75.75 0 0 1 1.06 1.06l-9 9a.75.75 0 0 1-1.06 0l-9-9a.75.75 0 0 1 1.06-1.06l7.72 7.72V3a.75.75 0 1 1 1.5 0v16.19z'
    />
  </svg>
);

export default DownArrow;
